import { Building } from 'features/building';
import { AppPage } from 'common/Layout';
import { useBuildingPage } from './use-building-page';

export const BuildingPage = () => {
  const { breadcrumbsLoading, breadcrumbs, building } = useBuildingPage();

  return (
    <AppPage
      breadcrumbs={{
        items: breadcrumbs,
        loading: breadcrumbsLoading,
      }}
      documentTitle={building?.name}
    >
      <Building />
    </AppPage>
  );
};
